import React from 'react';
import ReactDOM from 'react-dom';
import { MediaViewer } from '@atlaskit/media-viewer';
export var RenderMediaViewer = function RenderMediaViewer(_ref) {
  var mediaClientConfig = _ref.mediaClientConfig,
    onClose = _ref.onClose,
    selectedNodeAttrs = _ref.selectedNodeAttrs;
  var id = selectedNodeAttrs.id,
    _selectedNodeAttrs$co = selectedNodeAttrs.collection,
    collection = _selectedNodeAttrs$co === void 0 ? '' : _selectedNodeAttrs$co;
  var identifier = {
    id: id,
    mediaItemType: 'file',
    collectionName: collection
  };
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(MediaViewer, {
    collectionName: collection,
    items: [],
    mediaClientConfig: mediaClientConfig,
    selectedItem: identifier,
    onClose: onClose
  }), document.body);
};